import '../../css/main.css'
import './style.css'
import Menu from '../../common/menu.js';
import TopBar from "../../common/topBar";
import { useEffect, useRef, useState } from 'react';
import BaiscTable from '../../tables/default-table.js';
import BasicPagination from '../../pagination/basic.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext.js';
import { useData } from '../../../contexts/DataContext.js';
import DefaultLayout from '../../layouts/DefaultLayout.js';
import toast from 'react-hot-toast';
import TopCardSkeleton from '../../Skeleton/topCards.js';
import Loader from '../../loaders/loader.jsx';

export default function Clients() {

  
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [exportFilters, setExportFilters] = useState({
    start_date: '',
    end_date: '',
    filtered_month: new Date().getMonth(),
    filtered_year: new Date().getFullYear(),
    filter_type: 'custom_dates' // 'month_year' ou 'custom_dates'
  });
  
  const popupRef = useRef(null);
  const buttonRef = useRef(null);

  // Fechar popup ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target) && 
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setShowExportPopup(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Atualizar datas quando mês/ano mudar
  useEffect(() => {
    if (exportFilters.filter_type === 'month_year' && 
        exportFilters.filtered_year && 
        exportFilters.filtered_month !== '') {
      
      const { start, end } = getMonthStartEndDates(
        exportFilters.filtered_year,
        exportFilters.filtered_month
      );
      
      setExportFilters(prev => ({
        ...prev,
        start_date: start,
        end_date: end
      }));
    }
  }, [exportFilters.filtered_year, exportFilters.filtered_month, exportFilters.filter_type]);




const [create, setCreate] = useState(false);
const [edit, setEdit] = useState(null);
const [del, setDel] = useState(null);
const {pathname} = useLocation()
const {user,selectedMicrocredit,userRole,userInfo} = useAuth()
const data=useData()
const [loading,setLoading]=useState(false)
const navigate=useNavigate()
const [printing,setPrinting]=useState(false)
const [topFilters,setTopFilters]=useState({
     filtered_contract_year:new Date().getFullYear(),
     filtered_contract_month:new Date().getMonth()
})
const [hideFilters,setHideFilters]=useState(true)

let required_data=['bank_reports']

const [currentPage,setCurrentPage]=useState(1)
const [updateFilters,setUpdateFilters]=useState(null)
const [search,setSearch]=useState('')
const [filterOptions,setFilterOptions]=useState([])
let initial_filters={start_date:'',end_date:'',approval_status:'',payment_status:'',client_id:''}
const [filters,setFilters]=useState(initial_filters);

useEffect(()=>{ 
   if(!user || data.updateTable) return
   data.handleLoaded('remove',required_data)
   data._get(required_data,{
     bank_reports:{microcredit_id:selectedMicrocredit,search:search,page:currentPage,/*...topFilters,...filters,*/...data.getParamsFromFilters(filterOptions)},
    }) 
 },[user,pathname,search,currentPage,updateFilters])


 useEffect(()=>{
   data.handleLoaded('remove',required_data)
 },[updateFilters]) 



 useEffect(()=>{
   if(data.updateTable){
        data.setUpdateTable(null)
        data.handleLoaded('remove',required_data)
        setCurrentPage(1)
        data._get(required_data,{
           bank_reports:{microcredit_id:selectedMicrocredit,search:search,page:1,/*...topFilters,...filters,*/...data.getParamsFromFilters(filterOptions)},
         }) 
   }
},[data.updateTable])

/**
useEffect(()=>{data.setUpdateTable(Math.random())},[filters,topFilters])
 */

const Print =async (type,_data,info) => {

   
  
    let micro=user.microcredits.filter(i=>i.id==selectedMicrocredit)[0]

    let placeholders={
          nome_da_empresa:micro.name,
          data_inicio:filters.start_date,
          data_fim:filters.end_date,
          periodo_de_reporte:`${filters.start_date?.split('-')?.reverse()?.join('/') || '[Não especificado]'} até ${filters.end_date?.split('-')?.reverse()?.join('/') || '[Não especificado]'}`,
          endereco_da_empresa:micro.location || '[Não especificado]',
          provincia_da_empresa:micro.province || '[Não especificado]',
          telefone_da_empresa:`${micro.primary_contact || '-'} ${micro.secondary_contact ? ' / '+micro.secondary_contact : ''}`,
          email_da_empresa:micro.email || '[Não especificado]',
          numero_de_trabalhadores:micro.user_microcredits.length,
          gestor_da_empresa:micro.company_manager || '[Não especificado]',
          inicio_das_actividades:micro.start_of_activities?.split('-')?.reverse()?.join('/') || `[Não especificado]`
    }

    Object.keys(placeholders).forEach(key => {
        placeholders[key] = String(placeholders[key]);
    });

    const mappedData = _data.map(item => {
        const paid = item.paid || 0;
        const totalToPay = item.total_to_pay || 0;
        return [
            item.id,
            item.client?.name || '-',
            item.disbursement_date?.split('-')?.reverse()?.join('/'),
            data._cn(item.disbursement_value.toFixed(2)),
            item.reason || 'Não especificado',
            data._cn(((item.disbursement_value + item.fees) - item.total_expenses).toFixed(2)),
            getPaymentFrequency(item.number_of_days, item.number_of_installments),
            item.refund_date?.split('-')?.reverse()?.join('/'),
            `${item.fees_percentage}%`,
            data._cn((item.disbursement_value - paid <= 0 ? '0' : (item.disbursement_value - paid).toFixed(2))),
            data._cn((totalToPay - paid < 0 ? '0' : (totalToPay - paid).toFixed(2))),
            item.delay,
            '-' // Placeholder for the last column (you can replace it with actual logic later)
        ];
    });


    try{

        let response=await data.makeRequest({method:'post',url:`api/print-client-contract`,withToken:true,data:{
        microcredit_id:selectedMicrocredit,
        placeholders,
        document_type:'financial_report',
        table_data:mappedData,
        contracts:_data,
        ...info
        }, error: ``},0);

        if(info.save_report) data.setUpdateTable(Math.random())

        window.location.href=data.APP_BASE_URL+"/download-report/"+response

    }catch(e){
        toast.remove()
        let msg="Acorreu um erro, tente novamente"
        if(e.response){
            if(e.response.status==500){
                msg="Erro, inesperado. Contacte seu administrador"
            }
        }else if(e.code=='ERR_NETWORK'){
                msg="Verfique sua internet e tente novamente"
        }
        toast.error(msg)
    }
}
 
 const pages=[
    {name:'Relatório geral',page:'/cash-management/stats'},
    {name:'Relatório do banco central',page:'/cash-management/bank-stats'},
 ]

 const reqLoaded=data.loaded.includes('bank_reports')

 
/*function getPaymentFrequency(numberOfDays, numberOfInstallments) {
  if (numberOfInstallments <= 0 || numberOfDays <= 0) {
    return "Inválido";
  }

  const interval = numberOfDays / numberOfInstallments;
  const frequencyStandards = {
    "Diário": 1,
    "Semanal": 7,
    "Mensal": 30,
    "Anual": 365,
  };

  let closestFrequency = "Diário";
  let smallestDifference = Math.abs(interval - frequencyStandards["Diário"]);

  for (const [frequency, standardDays] of Object.entries(frequencyStandards)) {
    const difference = Math.abs(interval - standardDays);
    if (difference < smallestDifference) {
      smallestDifference = difference;
      closestFrequency = frequency;
    }
  }

  return closestFrequency;
}*/



function getPaymentFrequency(numberOfDays, numberOfInstallments) {
  if (numberOfInstallments <= 0 || numberOfDays <= 0) {
    return "Inválido";
  }

  const interval = numberOfDays / numberOfInstallments;

  // Standard frequencies in ascending order (days)
  const frequencyStandards = [
    { name: "Diário", days: 1 },
    { name: "Semanal", days: 7 },
    { name: "Mensal", days: 30 },
    { name: "Anual", days: 365 },
  ];

  // Check for an exact match first
  for (const freq of frequencyStandards) {
    if (interval === freq.days) {
      return freq.name;
    }
  }

  // If no exact match, find the highest standard that is <= interval
  let closestFrequency = "Diário"; // Default (smallest possible)
  for (const freq of frequencyStandards) {
    if (freq.days < interval) {
      closestFrequency = freq.name;
    } else {
      break; // Stop when standards exceed the interval
    }
  }

  return closestFrequency;
}




// Função corrigida para obter datas do mês
const getMonthStartEndDates = (year, month) => {
  // Ajuste para o formato de Date (meses 0-11)
  const monthIndex = parseInt(month);
  const yearNumber = parseInt(year);
  
  // Data de início SEMPRE será dia 1 do mês selecionado
  const startDate = new Date(yearNumber, monthIndex, 1);
  
  // Data final será o último dia do mês selecionado
  const endDate = new Date(yearNumber, monthIndex + 1, 0);
  
  // Formatar para YYYY-MM-DD
  const format = (date) => {
    const pad = (num) => num.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  };

  return {
    start: format(startDate),
    end: format(endDate)
  };
};

// Modifique o useEffect que atualiza as datas
useEffect(() => {
  if (topFilters.filtered_contract_year && 
      topFilters.filtered_contract_month !== '' &&
      topFilters.filtered_contract_month !== 'custom') {
    
    const { start, end } = getMonthStartEndDates(
      topFilters.filtered_contract_year,
      topFilters.filtered_contract_month
    );
    
    setFilters(prev => ({
      ...prev,
      start_date: start,
      end_date: end
    }));
  }
}, [topFilters.filtered_contract_year, topFilters.filtered_contract_month]);

// Atualize o handler de mudança de datas
const handleDateChange = (type, value) => {
  setFilters(prev => ({
    ...prev,
    [type]: value
  }));
  
  // Se alterou manualmente, marcar como customizado
  if (value && topFilters.filtered_contract_month !== 'custom') {
    setTopFilters(prev => ({
      ...prev,
      filtered_contract_month: 'custom',
      filtered_contract_year: 'custom'
    }));
  }
};


 const handleExport = async (saveReport = false) => {
    try {
      setPrinting(true);
      let response = await data.makeRequest({
        method: 'get',
        url: `api/contracts`,
        params: {
          all: true,
          microcredit_id: selectedMicrocredit || '',
          search: search,
          page: currentPage,
          /*start_date: exportFilters.start_date,
          end_date: exportFilters.end_date,*/
          start_date: filters.start_date,
          end_date: filters.end_date,

          save_report: saveReport 
        },
        error: ``,
        withToken: true
      }, 0);
      
      await Print('excel', response.data,{
        save_report:saveReport,
        /*start_date: exportFilters.start_date,
        end_date: exportFilters.end_date,*/
        start_date: filters.start_date,
        end_date: filters.end_date
      });
      setShowExportPopup(false);
    } catch (e) {
          toast.remove()
          let msg="Acorreu um erro, tente novamente"
          if(e.response){
            if(e.response.status==500){
                msg="Erro, inesperado. Contacte seu administrador"
            }
          }else if(e.code=='ERR_NETWORK'){
                msg="Verfique sua internet e tente novamente"
          }
          toast.error(msg)
    }
    setPrinting(false);
  };

  function PrintBankReport(filename){
    setPrinting(true)
    setTimeout(()=>{
         setPrinting(false)
         window.location.href=data.APP_BASE_URL+"/download-report/"+filename
         
    },3000)
  }


return (
    <>
     
     <DefaultLayout>

     <main className="dashboard-container">
   
     <div className="dashboard">
     <Menu/>
     <div className="main-dashboard">
          <TopBar activePage={'Relatório do banco de moçambique'}/>
       
          <div className="center">

            <div className={`inline-flex  bg-white overflow-hidden mb-5 rounded-[0.3rem]  shadow justify-between gap-x-3 px-2`}>
                         {pages.map((i,_i)=>(
                          <span  onClick={()=>navigate(i.page)} className={`py-2 text-[15px] relative cursor-pointer flex ${pathname==i.page ? '':'opacity-50'}`}>
                               <label className="cursor-pointer text-black">{i.name}</label>
                               {pathname==i.page && <label className="w-full absolute bottom-0 flex h-[3px] bg-custom_blue-300 rounde-t-[0.3rem]"></label>}
                          </span>
                         ))}
            </div>



            
            


                    <div className={`extra-filters ${hideFilters ? '_hide':''}`}>

                     <label onClick={()=>setHideFilters(!hideFilters)} className="underline sm:hidden text-[15px]  text-custom_blue-400 absolute top-4 cursor-pointer">{hideFilters ? 'Mostrar filtros':'Esconder filtros'}</label>

                     <div className="input-container">
                         <span className="flex w-full !opacity-70 !text-[15px]">Selecione o período para imprimir</span>
                       
                         <div className="inputs hidden">
                             <span>Mês</span>
                              <select onChange={(e)=>setTopFilters({...topFilters,filtered_contract_month:e.target.value})} value={topFilters.filtered_contract_month} className="text-[0.8rem] outline-none border-r border-r-black mr-2">
                                            <option value="custom" disabled>Customizado</option>
                                             {(data.months).map((i,_i)=>(
                                               <option value={_i}>{i}</option>
                                             ))}
                              </select>
                         </div>

                        <div className="inputs hidden">
                             <span>Ano</span>
                              <select onChange={(e)=>setTopFilters({...topFilters,filtered_contract_year:e.target.value})} value={topFilters.filtered_contract_year} className="text-[0.8rem] outline-none">
                                              <option value="custom" disabled>Customizado</option>
                                             {(data._bank_reports.contractsYearsFromStart || [new Date().getFullYear()]).map((i,_i)=>(
                                               <option value={i}>{i}</option>
                                             ))}
                            </select>
                         </div>


                         <div className="inputs">
                              <span>Data de inicio</span>
                              <input type="date" value={filters.start_date} onChange={(e) => handleDateChange('start_date', e.target.value)}  />
                         </div>

                              <div className="inputs">
                              <span>Data de fim</span>
                              <input type="date" value={filters.end_date} onChange={(e) => handleDateChange('end_date', e.target.value)}  />
                         </div>

                         
                    </div>

                    <div className="options">
                   
                    <span onClick={()=>{
                        setFilters(initial_filters)
                        setTopFilters({
                            filtered_contract_year:new Date().getFullYear(),
                            filtered_contract_month:new Date().getMonth()
                        })
                    }}>
                         <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path fill="#fff" d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z"/></svg> </span>
                    </div>
             </div>

               <div className="dasboard-item-list-container">
                   <div className="top-section">
                     <span  className="text-[18px]">Relatórios salvos</span>
                    {/**<div className="left-side flex items-center" style={{width:'100px'}}>
                       <div className="flex items-center">
                         <div onClick={()=>
                         data.setUpdateTable(Math.random())
                         } className="mr-2 cursor-pointer hover:opacity-65">
                              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"/></svg>
                         </div>
                        
                    </div> 
                    </div>*/}
                   
                      <div className="right-side relative">
        {printing ? (
          <Loader />
        ) : (
          <>
            <button
              ref={buttonRef}
              onClick={() => setShowExportPopup(!showExportPopup)}
              className="export-button flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md transition-colors"
            >
              <span>Imprimir novo relatório</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24">
                <path fill="#fff" d="M18 22a2 2 0 0 0 2-2v-5l-5 4v-3H8v-2h7v-3l5 4V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12zM13 4l5 5h-5V4z"></path>
              </svg>
            </button>

            {showExportPopup && (
              <div
                ref={popupRef}
                className="absolute right-0 mt-2 w-72 bg-white rounded-md shadow-lg z-50 border border-gray-200"
              >
                <div className="p-4">
                  {/* Cabeçalho com título e botão de fechar */}
                  <div className="flex justify-between items-center mb-3 hidden">
                    <h3 className="text-sm font-medium text-gray-700">
                      Opções de impressão
                    </h3>
                    <button
                      onClick={() => setShowExportPopup(false)}
                      className="text-gray-400 hover:text-gray-500"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </button>
                  </div>
                  
                  <div className="space-y-3  hidden">
                    {/* Seletor de tipo de filtro (mantido igual) */}
                    <div className="flex items-center space-x-4 mb-2">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          checked={exportFilters.filter_type === 'month_year'}
                          onChange={() => setExportFilters({
                            ...exportFilters,
                            filter_type: 'month_year'
                          })}
                          className="form-radio h-4 w-4 text-blue-600"
                        />
                        <span className="ml-2 text-sm text-gray-700">Mês/Ano</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          checked={exportFilters.filter_type === 'custom_dates'}
                          onChange={() => setExportFilters({
                            ...exportFilters,
                            filter_type: 'custom_dates'
                          })}
                          className="form-radio h-4 w-4 text-blue-600"
                        />
                        <span className="ml-2 text-sm text-gray-700">Datas específicas</span>
                      </label>
                    </div>

                    {exportFilters.filter_type === 'month_year' ? (
                      <>
                        <div>
                          <label className="block text-xs font-medium text-gray-500 mb-1">
                            Mês
                          </label>
                          <select
                            value={exportFilters.filtered_month}
                            onChange={(e) => setExportFilters({
                              ...exportFilters,
                              filtered_month: e.target.value
                            })}
                            className="w-full p-2 text-sm border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                          >
                            {data.months.map((month, index) => (
                              <option key={index} value={index}>{month}</option>
                            ))}
                          </select>
                        </div>
                        
                        <div>
                          <label className="block text-xs font-medium text-gray-500 mb-1">
                            Ano
                          </label>
                          <select
                            value={exportFilters.filtered_year}
                            onChange={(e) => setExportFilters({
                              ...exportFilters,
                              filtered_year: e.target.value
                            })}
                            className="w-full p-2 text-sm border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                          >
                            {(data._bank_reports.contractsYearsFromStart || [new Date().getFullYear()]).map((year) => (
                              <option key={year} value={year}>{year}</option>
                            ))}
                          </select>
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          <label className="block text-xs font-medium text-gray-500 mb-1">
                            Data de início
                          </label>
                          <input
                            type="date"
                            value={exportFilters.start_date}
                            onChange={(e) => setExportFilters({
                              ...exportFilters,
                              start_date: e.target.value
                            })}
                            className="w-full p-2 text-sm border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                          />
                        </div>
                        
                        <div>
                          <label className="block text-xs font-medium text-gray-500 mb-1">
                            Data de fim
                          </label>
                          <input
                            type="date"
                            value={exportFilters.end_date}
                            onChange={(e) => setExportFilters({
                              ...exportFilters,
                              end_date: e.target.value
                            })}
                            className="w-full p-2 text-sm border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  
                  {/* Botões de ação atualizados */}
                  <div className="flex justify-between gap-2 mt-4">
                    <button
                      onClick={() => handleExport(true)}
                      disabled={!filters.start_date || !filters.end_date}
                      className={`flex-1 flex px-3 items-center justify-center gap-2 py-2 text-sm text-white rounded-md ${
                        (/**!exportFilters.start_date || !exportFilters.end_date*/!filters.start_date || !filters.end_date)
                          ? 'bg-gray-400 cursor-not-allowed pointer-events-none'
                          : 'bg-blue-500 hover:bg-blue-600'
                      }`}
                    >
                      <svg  xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                      </svg>
                     Salvar e Imprimir
                    </button>
                    <button
                      onClick={() => handleExport(false)}
                      disabled={!filters.start_date || !filters.end_date}
                      className={`flex-1 flex px-3  items-center justify-center gap-2 py-2 text-sm text-white rounded-md ${
                        (/**!exportFilters.start_date || !exportFilters.end_date*/!filters.start_date || !filters.end_date)
                          ? 'bg-gray-400 cursor-not-allowed pointer-events-none'
                          : 'bg-green-500 hover:bg-green-600'
                      }`}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                      </svg>
                      Apenas Imprimir
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
                  </div>

               <BaiscTable notClickable={true} empty_table_text={'Nenhum relatório salvo foi encontrado'} loaded={data._loaded.includes('bank_reports')} header={[
                    <BaiscTable.MainActions hide={userRole=="operator" && !userInfo?.permissions?.contracts?.includes('delete')} data={data} options={{
                      deleteFunction:'default',
                      deleteUrl:'api/bank-reports/delete'}
                    } items={data._bank_reports?.data || []}/>,
                      'ID',
                      'Nome do colaborador',
                      'Data de criação',
                      'Período de início',
                      'Período de fim',
                      'Total contratos'
                    ]
               }

               body={(data._bank_reports?.data || []).map((i,_i)=>(
                         <BaiscTable.Tr>
                          <BaiscTable.Td>
                              <BaiscTable.Actions hide={userRole=="operator" && !userInfo?.permissions?.contracts?.includes('delete')} data={data}  options={{
                                   deleteFunction:'default',
                                   deleteUrl:'api/bank-reports/delete',
                                   id:i.id}
                              }/>
                          </BaiscTable.Td>
                          <BaiscTable.Td>{i.id}</BaiscTable.Td>
                          <BaiscTable.Td>{i.micro_user.name}</BaiscTable.Td>
                          <BaiscTable.Td>{i.created_at.split('T')[0].split('-')?.reverse()?.join('/')}</BaiscTable.Td>
                          <BaiscTable.Td>{i.start_date?.split('-')?.reverse()?.join('/') || 'Não especificado'}</BaiscTable.Td>
                          <BaiscTable.Td>{i.end_date?.split('-')?.reverse()?.join('/') || 'Não especificado'}</BaiscTable.Td>
                          <BaiscTable.Td>{i.table_data.length}</BaiscTable.Td>
                          <BaiscTable.AdvancedActions hide={printing} data={data} w={200} id={i.id} items={[
                              {name:'Imprimir relatório',onClick:()=>{
                                 PrintBankReport(i.filename)
                              },icon:(
                                <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24" transform="" id="injected-svg">
                                  <path d="m19,7h-1V2H6v5h-1c-1.65,0-3,1.35-3,3v7c0,1.1.9,2,2,2h2v3h12v-3h2c1.1,0,2-.9,2-2v-7c0-1.65-1.35-3-3-3Zm-11-3h8v3h-8v-3Zm8,16h-8v-4h8v4Zm4-3h-2v-3H6v3h-2v-7c0-.55.45-1,1-1h14c.55,0,1,.45,1,1v7Z"/>
                                  <path d="M14 11H18V12H14z"/>
                                </svg>
                              )
                              },
                             ]}/>
                         </BaiscTable.Tr>
                    ))}
          />

               <BasicPagination show={data._loaded.includes('bank_reports')} from={'bank_reports'} setCurrentPage={setCurrentPage} total={data._bank_reports?.total}  current={data._bank_reports?.page} last={data._bank_reports?.totalPages}/>


               </div>

          </div>

          
     </div>
     </div>
     </main>

     </DefaultLayout>
    </>
  );
}
